import { getDefaultUserLinkCopy } from 'ComponentLibrary/src/piazza/text/UserLink/UserLink'
import { useTranslation } from 'react-i18next'

export function useUserLinkCopy() {
    const { t: tCommon } = useTranslation('terminology', { keyPrefix: 'common' })

    return getDefaultUserLinkCopy(tCommon)
}
